
import XSwitch from 'vux/src/components/x-switch/index.vue'


export default {
components: {
XSwitch
},
data() {
return {
value: '1'
}
}
}



// WEBPACK FOOTER //
// ./src/components/design/components/control_attribute/sy-address-attr.vue